import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 8h-2a2 2 0 0 0 -2 2a2 2 0 1 1 -4 0v-1a2 2 0 0 0 -2 -2h-1a2 2 0 0 1 -2 -2v-.5","key":"svg-0"}],["path",{"d":"M3 12h3a2 2 0 0 1 2 2v.5a1.5 1.5 0 0 0 1.5 1.5a1.5 1.5 0 0 1 1.5 1.5v3.25","key":"svg-1"}],["path",{"d":"M15 20.5v-3.5a2 2 0 0 1 2 -2h3.5","key":"svg-2"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-3"}]]

const IconWorldMap = createReactComponent('outline', 'world-map', 'WorldMap', __iconNode);

export default IconWorldMap;